<template>
  <div class="floating-contact" :class="{ visible: isVisible }">
    <div class="contact-actions">
      <button class="action-btn wechat" type="button" :title="wechatLabel">
        <img src="/微信.png" :alt="wechatLabel" />
        <span class="action-popover qr-popover">
          <div style="display:flex;">
            <div style="margin-right: 20px">
              <img class="qr-image" src="/wechat-im.png" :alt="wechatLabel" />
              <strong>{{ wechatLabel }}</strong>
            </div>
            <div>
              <img class="qr-image" src="/WhatsApp.jpg" :alt="wechatLabel" />
              <strong>WhatsApp</strong>
            </div>
          </div>
        </span>
      </button>

      <a class="action-btn phone" :href="phoneLink" :title="callLabel">
        <img src="/电话- icon-copy.png" :alt="callLabel" />
        <span class="action-popover phone-popover">
          <strong>{{ mobileLabel }}</strong>
          <span>{{ phone.mobile }}</span>
          <span>+86 19732612158</span>
        </span>
      </a>

      <button class="action-btn backtop" type="button" @click="scrollTop" :title="backTopLabel">
<!--        <span class="up-icon"></span>-->
        <img src="../../../public/top.png" style="width: 50px; height: 50px">
      </button>
    </div>
  </div>
</template>

<script>
import { phoneNumbers } from "../../data/site";

export default {
  name: "FloatingContact",
  data() {
    return {
      isVisible: false,
      phone: phoneNumbers
    };
  },
  computed: {
    wechatLabel() {
      return this.locale === "zh-CN" ? "微信咨询" : "WeChat";
    },
    mobileLabel() {
      return this.locale === "zh-CN" ? "手机咨询" : "Mobile";
    },
    callLabel() {
      return this.locale === "zh-CN" ? "电话联系" : "Call";
    },
    backTopLabel() {
      return this.locale === "zh-CN" ? "返回顶部" : "Back to Top";
    },
    phoneLink() {
      return "tel:" + this.phone.mobile.replace(/\s+/g, "");
    }
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isVisible = window.scrollY > 120;
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.floating-contact {
  position: fixed;
  right: 18px;
  top: 50%;
  z-index: 60;
  opacity: 0;
  visibility: hidden;
  transform: translateY(calc(-50% + 16px));
  transition: opacity 0.28s ease, transform 0.28s ease, visibility 0.28s ease;
}

.floating-contact.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%);
}

.contact-actions {
  display: grid;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 18px 36px rgba(11, 39, 82, 0.18);
}

.action-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 66px;
  height: 66px;
  border: 0;
  color: #ffffff;
  cursor: pointer;
}

.action-btn:first-child {
  border-radius: 15px 15px 0 0;
}

.action-btn:last-child {
  border-radius: 0 0 15px 15px;
}

.action-btn:hover {
  z-index: 2;
}

.action-btn.wechat {
  background: transparent;
}

.action-btn.phone {
  background: transparent;
}

.action-btn.backtop {
  background: transparent;
}



.action-btn:last-child::after {
  display: none;
}

.action-btn img {
  display: block;
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.action-popover {
  position: absolute;
  top: 50%;
  right: calc(100% + 14px);
  color: #1f2a37;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(15, 35, 64, 0.18);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(12px, -50%);
  transition: opacity 0.24s ease, transform 0.24s ease, visibility 0.24s ease;
}

.action-popover::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -7px;
  width: 14px;
  height: 14px;
  background: #ffffff;
  transform: translateY(-50%) rotate(45deg);
}

.action-btn:hover .action-popover {
  opacity: 1;
  visibility: visible;
  transform: translate(0, -50%);
}

.qr-popover {
  display: grid;
  justify-items: center;
  gap: 10px;
  width: 500px;
  padding: 20px;
  border-radius: 18px;
}

.action-btn .qr-image {
  display: block;
  width: 210px;
  height: 210px;
  object-fit: contain;
  background: #ffffff;
  border: 1px solid rgba(26, 111, 203, 0.16);
  border-radius: 12px;
  margin-bottom: 10px;
}

.qr-popover strong {
  position: relative;
  z-index: 1;
  color: var(--brand-blue-deep);
  font-size: 15px;
}

.phone-popover {
  display: grid;
  gap: 6px;
  min-width: 186px;
  padding: 16px 20px;
  border-radius: 18px;
  text-align: left;
  white-space: nowrap;
}

.phone-popover strong,
.phone-popover span {
  position: relative;
  z-index: 1;
}

.phone-popover strong {
  color: #7b8794;
  font-size: 13px;
  font-weight: 500;
}

.phone-popover span {
  color: var(--brand-blue-deep);
  font-size: 19px;
  font-weight: 700;
}

.up-icon {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
}

.up-icon::before,
.up-icon::after {
  content: "";
  position: absolute;
  left: 50%;
  background: #fff;
  transform: translateX(-50%);
}

.up-icon::before {
  top: 2px;
  width: 12px;
  height: 12px;
  clip-path: polygon(50% 0, 100% 60%, 70% 60%, 70% 100%, 30% 100%, 30% 60%, 0 60%);
}

.up-icon::after {
  bottom: -4px;
  width: 4px;
  height: 18px;
}

@media (max-width: 900px) {
  .floating-contact {
    right: 12px;
    bottom: 12px;
    top: auto;
    transform: translateY(20px);
  }

  .floating-contact.visible {
    transform: translateY(0);
  }

  .action-btn {
    width: 48px;
    height: 48px;
  }

  .contact-actions {
    border-radius: 12px;
  }

  .action-btn:first-child {
    border-radius: 12px 12px 0 0;
  }

  .action-btn:last-child {
    border-radius: 0 0 12px 12px;
  }

  .action-btn img {
    width: 24px;
    height: 24px;
  }

  .action-popover {
    display: none;
  }

  .phone-popover {
    min-width: 168px;
  }
}
</style>
